/* eslint-disable import/no-cycle, import/prefer-default-export */
import { apiHttp } from '../axiosApi'
import { publicEmailClick } from '../config/apiRoute'

/** Avisa que alguien abriÃ³ un link de un mail de notificaciÃ³n. Los mails
 *  llevan `?e=<token>` en vez del redirect de Mailgun (que rompÃ­a los
 *  universal links de iOS). Dispara y se olvida: nunca rechaza. */
export const reportEmailClick = async (token, url) => {
  try {
    await apiHttp(
      'POST',
      `${publicEmailClick}${encodeURIComponent(token)}`,
      { url },
      { headers: { Accept: 'application/json', 'Content-Type': 'application/json' } },
      false,
      'v3',
    )
  } catch (e) {
    // sin efecto para quien abre el link
  }
}
